__turbopack_context__.v({
  "chat": "sleep-expert-module-scss-module__2x0aqq__chat",
  "chatText": "sleep-expert-module-scss-module__2x0aqq__chatText",
  "phone": "sleep-expert-module-scss-module__2x0aqq__phone",
  "sleepExpertAffirm": "sleep-expert-module-scss-module__2x0aqq__sleepExpertAffirm",
  "sleepExpertReview": "sleep-expert-module-scss-module__2x0aqq__sleepExpertReview",
  "sleepExpertWrapper": "sleep-expert-module-scss-module__2x0aqq__sleepExpertWrapper",
});
